<app-top-nav *ngIf="menu"></app-top-nav>
<app-toast-container aria-live="polite" aria-atomic="true"></app-toast-container>

<app-spinner></app-spinner>

<router-outlet></router-outlet>

